import React from "react";
import SectionHeading from "@/components/common/SectionHeading";
import { Reveal } from "@/components/common/Reveal";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { useSettings } from "@/context/SettingsContext";

export default function FAQ({ chapter = "07", limit }) {
  const { faqs = [] } = useSettings();
  const list = limit ? faqs.slice(0, limit) : faqs;
  return (
    <section className="container-page py-20 lg:py-28" data-testid="faq-section" id="faq">
      <div className="grid gap-10 lg:grid-cols-12">
        <div className="lg:col-span-4">
          <SectionHeading
            chapter={chapter}
            eyebrow="FAQ"
            title="Questions, answered clearly"
            intro="Straight answers about how sourcing enquiries work with us."
          />
        </div>
        <Reveal className="lg:col-span-8">
          <Accordion type="single" collapsible className="w-full border-t border-[#D9E0E4]">
            {list.map((f, i) => (
              <AccordionItem key={i} value={`item-${i}`} className="border-b border-[#D9E0E4]">
                <AccordionTrigger
                  className="text-left font-heading font-semibold text-[16px] lg:text-[17px] text-navy hover:text-teal py-5 hover:no-underline"
                  data-testid={`faq-trigger-${i}`}
                >
                  {f.q}
                </AccordionTrigger>
                <AccordionContent className="text-[15px] leading-relaxed text-muted-foreground pb-5">
                  {f.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </Reveal>
      </div>
    </section>
  );
}
